module.exports = __webpack_public_path__ + "img/67.beab1732.jpg";